import api from "./api"

export const getSupplierFormData = async () => {
  const response = await api.get("/suppliers/form-data")
  return response.data
}

export const getSuppliers = async () => {
  const response = await api.get("/suppliers")
  return response.data
}

export const getSupplierById = async (supplierId) => {
  const response = await api.get(`/suppliers/${supplierId}`)
  return response.data
}

export const createSupplier = async (payload) => {
  const response = await api.post("/suppliers", payload)
  return response.data
}

export const updateSupplier = async (supplierId, payload) => {
  const response = await api.put(`/suppliers/${supplierId}`, payload)
  return response.data
}

export const deleteSupplier = async (supplierId) => {
  const response = await api.delete(`/suppliers/${supplierId}`)
  return response.data
}

export const activateSupplier = async (supplierId) => {
  const response = await api.patch(`/suppliers/${supplierId}/activate`)
  return response.data
}

export const deactivateSupplier = async (supplierId) => {
  const response = await api.patch(`/suppliers/${supplierId}/deactivate`)
  return response.data
}